import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router';
import Button from '../../../components/common/Button';
import { SETTLED_BETS } from '../../../routes/paths';
import Translation from '../../i18n/Translation';

export const Restrictions = ({ history }) => {
  const openSetPINPage = () => {
    window.open(api_config.online_set_pin_url, '_blank');
    return false;
  };

  return (
    <div className="transfer-restrictions">
      <div className="transfer-restrictions__container">
        <div className="transfer-restrictions__header">
          <Translation section="transfer" label="rectrictionsHeader" />
        </div>
        <div className="transfer-restrictions__section">
          <h2 className="transfer-restrictions__section-header">
            <Translation section="onlinePIN" label="needsPIN" />
          </h2>
          <p className="transfer-restrictions__section-paragraph">
            <Translation section="onlinePIN" label="needsPINDetails" />
          </p>
        </div>
        <div className="transfer-restrictions__buttons">
          <Button className="transfer-restrictions__button" onClick={openSetPINPage}>
            <Translation section="onlinePIN" label="submitSet" />
          </Button>
          <Button
            className="transfer-restrictions__button button--secondary"
            onClick={() => history.push(SETTLED_BETS)}
          >
            <Translation section="common" label="backToSettled" />
          </Button>
        </div>
      </div>
    </div>
  );
};

Restrictions.propTypes = {
  history: PropTypes.object.isRequired
};

export default withRouter(Restrictions);
